// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestPermission__popup-be4576 {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  border: 1px solid var(--base-30);
  box-sizing: border-box;
  overflow: auto;
  padding: 24px;
  min-width: 480px;
  border-radius: 8px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1);
  background-color: var(--base-0);
  z-index: 2;
}

.RequestPermission__title-ad6155 {
  color: var(--base-110);
  font: var(--font-body-2);
  font-size: 20px;
  font-weight: bold;
  margin-bottom: var(--indent-16px);
}

.RequestPermission__text-b4d675 {
  color: var(--base-110);
  font: var(--font-body-4);
  width: 100%;
  margin-bottom: var(--indent-24px);
}

.RequestPermission__action-panel-a95b13 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.RequestPermission__button-b321ee {
  margin-inline-start: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/RequestPermission/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,6BAAA;EACA,gCAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;EACA,+BAAA;EACA,UAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,iCAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".popup {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  border: 1px solid var(--base-30);\n  box-sizing: border-box;\n  overflow: auto;\n  padding: 24px;\n  min-width: 480px;\n  border-radius: 8px;\n  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1);\n  background-color: var(--base-0);\n  z-index: 2;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: var(--indent-16px);\n}\n\n.text {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  width: 100%;\n  margin-bottom: var(--indent-24px);\n}\n\n.action-panel {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button {\n  margin-inline-start: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `RequestPermission__popup-be4576`,
	"title": `RequestPermission__title-ad6155`,
	"text": `RequestPermission__text-b4d675`,
	"action-panel": `RequestPermission__action-panel-a95b13`,
	"actionPanel": `RequestPermission__action-panel-a95b13`,
	"button": `RequestPermission__button-b321ee`
};
module.exports = ___CSS_LOADER_EXPORT___;
